<template>
  <span class="quote__copy-group" @click.prevent="copyQuoteText">
    <span class="quote__info-copy"> {{ quoteText }}</span>
    <svg class="quote__btn-copy" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2.19461 2.19559C2.31964 2.07056 2.4892 2.00033 2.66602 2.00033H8.66602C8.84283 2.00033 9.0124 2.07056 9.13742 2.19559C9.26244 2.32061 9.33268 2.49018 9.33268 2.66699V3.33366C9.33268 3.70185 9.63116 4.00033 9.99935 4.00033C10.3675 4.00033 10.666 3.70185 10.666 3.33366V2.66699C10.666 2.13656 10.4553 1.62785 10.0802 1.25278C9.70516 0.877706 9.19645 0.666992 8.66602 0.666992H2.66602C2.13558 0.666992 1.62687 0.877706 1.2518 1.25278C0.876729 1.62785 0.666016 2.13656 0.666016 2.66699V8.66699C0.666016 9.19743 0.876729 9.70613 1.2518 10.0812C1.62687 10.4563 2.13558 10.667 2.66602 10.667H3.33268C3.70087 10.667 3.99935 10.3685 3.99935 10.0003C3.99935 9.63214 3.70087 9.33366 3.33268 9.33366H2.66602C2.4892 9.33366 2.31964 9.26342 2.19461 9.1384C2.06959 9.01337 1.99935 8.8438 1.99935 8.66699V2.66699C1.99935 2.49018 2.06959 2.32061 2.19461 2.19559ZM6.66602 7.33366C6.66602 6.96547 6.96449 6.66699 7.33268 6.66699H13.3327C13.7009 6.66699 13.9993 6.96547 13.9993 7.33366V13.3337C13.9993 13.7018 13.7009 14.0003 13.3327 14.0003H7.33268C6.96449 14.0003 6.66602 13.7018 6.66602 13.3337V7.33366ZM7.33268 5.33366C6.22811 5.33366 5.33268 6.22909 5.33268 7.33366V13.3337C5.33268 14.4382 6.22811 15.3337 7.33268 15.3337H13.3327C14.4373 15.3337 15.3327 14.4382 15.3327 13.3337V7.33366C15.3327 6.22909 14.4373 5.33366 13.3327 5.33366H7.33268Z" fill="#526c82cc"/>
    </svg>
    <transition name="fade-copy">
      <span v-if="messageCopy" class="quote__message-copy">{{$t('copied')}}</span>
    </transition>
  </span>
</template>

<script>
export default {
  name: 'QuoteCopyButton',
  props: {
    quoteText: { type: [String, Number] }
  },
  data () {
    return {
      messageCopy: false
    }
  },
  methods: {
    copyQuoteText () {
      navigator.clipboard.writeText(this.quoteText)
      this.messageCopy = true
      setTimeout(() => {
        this.messageCopy = false
      }, 2000)
    }
  }
}
</script>

<style>
  .fade-copy-enter-active, .fade-copy-leave-active {
    transition: opacity .2s ease;
  }
  .fade-copy-enter, .fade-copy-leave-to /* .fade-leave-active до версии 2.1.8 */ {
    opacity: 0;
    transition: opacity .2s ease;
  }
</style>
